<template>
  <div class="container">
    <sign-up />
  </div>
</template>

<script>
import SignUp from '../SignUp.vue';

export default {
    components: {
        SignUp
    }
}
</script>

<style lang="scss" scoped>
.container {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  max-width: 374px;
}
</style>